var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMatchingGreen = function SvgIconMatchingGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.991 61.903c0 15.9-12.987 28.791-29.004 28.791-16.018 0-29.005-12.891-29.005-28.791S45.97 33.112 61.987 33.112c16.017 0 29.004 12.891 29.004 28.791Zm-81.982 0h52.986V9.306H9.01v52.597Z",
    fill: "url(#icon_matching_green_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_matching_green_svg__a",
    x1: 9.009,
    y1: 50,
    x2: 90.991,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CDD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#7ADEDA"
  })))));
};
export default SvgIconMatchingGreen;